module.exports = __webpack_public_path__ + "f8092e224d586f4576c2a4ecfb8cbcc0.png";